import { onMounted, onUnmounted } from 'vue';

const LIVE_ROOM_STATUS_CHANNEL_NAME = 'aimeta_live_status_channel';

export function useLiveRoomListPolling(refresh: () => void) {
  const onVisibility = () => {
    if (document.visibilityState === 'visible') {
      refresh();
    }
  };

  let channel: BroadcastChannel | null = null;

  onMounted(() => {
    document.addEventListener('visibilitychange', onVisibility);
    if (typeof BroadcastChannel !== 'undefined') {
      channel = new BroadcastChannel(LIVE_ROOM_STATUS_CHANNEL_NAME);
      channel.onmessage = (event) => {
        if (event.data?.action === 'refresh') {
          refresh();
        }
      };
    }
  });

  onUnmounted(() => {
    document.removeEventListener('visibilitychange', onVisibility);
    if (channel) {
      channel.close();
    }
  });
}

export function notifyLiveRoomListRefresh() {
  if (typeof BroadcastChannel !== 'undefined') {
    const channel = new BroadcastChannel(LIVE_ROOM_STATUS_CHANNEL_NAME);
    channel.postMessage({ action: 'refresh' });
    setTimeout(() => channel.close(), 100);
  }
}
